export default __webpack_public_path__ + "static/media/dashboard_active.d9b02809.svg";